import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Vue from 'vue'
import '../src/style/global.css'
import App from './App.vue'
import './assets/iconfont/iconfont.css'
import router from './router'
import utils from './utils/index'
import axios from 'axios'
import store from "./store/index.js"

Vue.prototype.$store = store
Vue.prototype.$axios = axios;

Vue.prototype.$utils = utils
Vue.config.productionTip = false

Vue.use(ElementUI)
const baseSize = 16
function setRem () {
    const scale = document.documentElement.clientWidth / 1920
    document.documentElement.style.fontSize = baseSize * Math.min(scale, 2) + 'px'
}
router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
})
setRem()
window.onresize = function () {
  setRem()
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
